// removed by extract-text-webpack-plugin
module.exports = {"inputWeight":"qempo_InputWeight_inputWeight-2nZiNG2","lightBlue":"qempo_InputWeight_lightBlue-3Y6ibf3","red":"qempo_InputWeight_red-3VrdAIi","yellow":"qempo_InputWeight_yellow-3QiI5Dd","weight":"qempo_InputWeight_weight-3UfRDQY","units":"qempo_InputWeight_units-3MuEcMI","unit":"qempo_InputWeight_unit-Z-cqVc1","selected":"qempo_InputWeight_selected-2xek5Kx"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/InputWeight/InputWeight.scss
// module id = 1635
// module chunks = 0